export const awaitingTableHeaders = [
  "Fecha solicitud",
  "Solicitante",
  "Tipo",
  "Inmueble Objetivo",
  "Ingresos",
]

export const awaitingTableBody = [
  {
    data: "formattedDate",
    classname: "",
  },
  {
    data: "applicant",
    classname: "",
  },
  {
    data: "userTypeText",
    classname: "",
  },
  {
    data: "property",
    classname: "",
  },
  {
    data: "incomeText",
    classname: "",
  },
]
